<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><span class="right_1" epub:type="pagebreak" id="page_6" title="6"><img alt="images" height="763" src="images/f0006-01.jpg" width="617"/></span></p>
<section epub:type="chapter" title="PART ONE NUTRITION LOVE YOUR HUNGER">
<header>
<p class="h2pn" id="pt1"><span class="right_1" epub:type="pagebreak" id="page_7" title="7"><a href="#/text/nav#rpt1"><span class="bro">PART ONE</span></a></span></p>
<div class="hide"><hr/></div>
<p class="h2p"><a href="#/text/nav#rpt1"><span class="whi">NUTRITION</span></a></p>
<div class="hide"><hr/></div>
<p class="h2ps"><a href="#/text/nav#rpt1"><span class="whi">Love Your Hunger</span></a></p>
<div class="hide"><hr/></div>
</header>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062482884_Part_1.vue?57400b02